export default __webpack_public_path__ + "static/media/sortinglaptop.16e22213.png";